import MoveBadge from "../components/svg/MoveBadge";

export const GameVariants = {
    STANDARD: "standard",
    JUMPSTART: "jumpstart",
    //This is for custom rules - probably need a new name at some point
    FUN: "fun"
}

export const TimeVariants = {
    BULLET: {imageSrc: "/bullet_symbol.png", title: "Bullet", value: "bullet"},
    BLITZ: {imageSrc: "/blitz_symbol.png", title: "Blitz", value: "blitz"},
    RAPID: {imageSrc: "/rapid_symbol.png", title: "Rapid", value: "rapid"},
    CLASSIC: {imageSrc: "/classic_symbol.png", title: "Classical", value: "classic"}
}

export const MoveRatingCategories = {
    BEST_MOVE: {
        symbol: (size) => <MoveBadge size={size} color="#5c8b4a" star/>,
        title: "Best move",
        color: "#5c8b4a",
        showInList: false
    },
    GOOD_MOVE: {
        symbol: (size) => <MoveBadge size={size} color="#86b86b" label="✓"/>,
        title: "Good move",
        color: "#86b86b",
        showInList: false
    },
    ALRIGHT_MOVE: {
        symbol: (size) => <MoveBadge size={size} color="#a3ac9e" label="~"/>,
        title: "Alright move",
        color: "#a3ac9e",
        showInList: false
    },
    INACCURACY: {
        symbol: (size) => <MoveBadge size={size} color="#e3ad3c" label="?!"/>,
        title: "Inaccuracy",
        color: "#e3ad3c",
        showInList: true
    },
    MISTAKE: {
        symbol: (size) => <MoveBadge size={size} color="#e0814a" label="?"/>,
        title: "Mistake",
        color: "#e0814a",
        showInList: true
    },
    BLUNDER: {
        symbol: (size) => <MoveBadge size={size} color="#c4573f" label="??"/>,
        title: "Blunder",
        color: "#c4573f",
        showInList: true
    }
}
